module.exports = __webpack_public_path__ + "static/image146-18a677503ef528588064abb3fee35289.jpg";